import * as React from 'react';
import { cn } from '../lib/cn.js';

export function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-[var(--control-height)] w-full min-w-0 rounded-control border border-border-strong',
        'bg-surface px-3 text-body text-ink transition-colors duration-[var(--duration-exit)] ease-standard',
        'placeholder:text-faint',
        'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-muted',
        'aria-invalid:border-danger',
        'file:mr-3 file:border-0 file:bg-transparent file:text-secondary file:font-medium file:text-ink',
        className,
      )}
      {...props}
    />
  );
}
